// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3mgT7","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3tQ8K","obliqueLine":"membershipbadge_obliqueLine__3QHvN"};